import React, { useRef } from 'react'
import { SpinnerDotted } from '../atoms'
import { no_data_icon } from '../../../assets/images'
import { DownloadPngButton } from '../pngExport'

const Table = ({ headers, customHeaders, data, tableschema, loading = false, custom_th = '', classes = '', tableClasses = '', tableHeight='100%', headerClasses = '', tableHeaderClasses = '', showDownload = true, downloadName = 'table', ...rest }) => {
  const tableRef = useRef(null)
  if (!headers) {
    return null
  }
  const tableHeaders = customHeaders || headers
  const check = ( data && data.length === 0 ) || loading
  return (
    <div ref={tableRef} className={`overflow-x-auto rounded-ds-md border border-gray-250 bg-white shadow-ds-sm ${classes}`}>
      {showDownload && !check && (
        <div className='flex justify-end px-2 pt-2' data-download-ignore='true'>
          <DownloadPngButton nodeRef={tableRef} fileName={downloadName} />
        </div>
      )}
      { custom_th && custom_th}
      <table className={ `min-w-full table-fixed text-xs border-collapse ${tableClasses}`} style={{height: tableHeight}}>
        <thead className={`bg-gray-50 ${tableHeaderClasses}`}>
          <tr>
            {!custom_th &&
              tableHeaders.map((item, index) => {
                return (
                  <th scope='col' key={typeof item === 'string' ? item : `header-${index}`} className={`text-2xs font-bold text-gray-600 py-2.5 ${headerClasses} uppercase pl-4 pr-4 text-left tracking-widest truncate border-b border-gray-250 bg-gray-50`}>
                    {typeof item === 'string' ? item.replace(/_/g, ' ') : item}
                  </th>
                )
              })
            }
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-200 bg-white'>
          {!check &&
            data.map((item, index) => {
              return tableschema({ data: item, headers, index, length: data.length, ...rest })
            })}
        </tbody>
      </table>
      { check && (
        <div className='grid grid-cols-1 py-16'>
          { !loading ?
            <React.Fragment>
              <img src={no_data_icon} alt='' className='m-auto inline-block h-14 w-16' />
              <span className='m-auto mt-2 text-xs font-medium text-gray-600'>No data found</span>
            </React.Fragment>
            :
            <SpinnerDotted classes='m-auto' />
          }
        </div>
      )}
    </div>
  )
}
Table.defaultProps = {
  tableClasses: '',
};

export default Table
